export const landingLinks = {
  heroCtaPrimary: { label: "Get Started Free", href: "/signup" },
  heroCtaSecondary: { label: "View Pricing", href: "/pricing" },
  navigation: [
    { label: "Features", href: "/features" },
    { label: "Pipeline", href: "/pipeline" },
    { label: "Pricing", href: "/pricing" },
  ],
  features: [
    { label: "For Agents", href: "/features#agents" },
    { label: "For Lawyers", href: "/features#lawyers" },
    { label: "For Buyers", href: "/features#buyers" },
  ],
  footer: [
    { label: "Features", href: "/features" },
    { label: "Pipeline", href: "/pipeline" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
  ],
};
